export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: "・Les informations à remplir dans le plan d'amélioration sont affichées en {toCompanyName}.\n・Les pièces jointes sont affichées en {toCompanyName}, et seul le nom du fichier sera affiché.",
    },
    chat: {
      card_title: 'Message',
      input_area_description: "Vous pouvez envoyer un message à {toCompanyName} concernant le plan d'amélioration",
      send_confirm: {
        modal_title: 'Vérifier le message à envoyer',
        confirm_text: 'Voulez-vous vraiment envoyer ce message ?',
        confirm_text_near_by_check_box: 'Message vérifié',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: 'Supprimer ce message',
        confirm_text: 'Voulez-vous vraiment supprimer ce message ?',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: "Envoyer l'historique",
        send_status: {
          success: 'Envoyé',
          failure: "Échec de l'envoi",
        },
      },
    },
  },
}
